'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dIcon$0024$002dIcon$002dName from "./presto.-Icon$-Icon-Name.js";
var $p;
/** @constructor */
function $c_Lpresto_Icon$IconName$$anon$1(_$ordinal$2, \u03b4name$2, outer) {
  this.cxP = 0;
  this.a8n = null;
  this.cxP = _$ordinal$2;
  this.a8n = \u03b4name$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_Icon$IconName$$anon$1 as $c_Lpresto_Icon$IconName$$anon$1 };
$p = $c_Lpresto_Icon$IconName$$anon$1.prototype = new $j_presto$002e$002dIcon$0024$002dIcon$002dName.$h_Lpresto_Icon$IconName();
$p.constructor = $c_Lpresto_Icon$IconName$$anon$1;
/** @constructor */
function $h_Lpresto_Icon$IconName$$anon$1() {
}
export { $h_Lpresto_Icon$IconName$$anon$1 as $h_Lpresto_Icon$IconName$$anon$1 };
$h_Lpresto_Icon$IconName$$anon$1.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a8n;
});
$p.l = (function() {
  return this.a8n;
});
var $d_Lpresto_Icon$IconName$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Icon$IconName$$anon$1, "presto.Icon$IconName$$anon$1", ({
  KB: 1,
  Kz: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_Icon$IconName$$anon$1 as $d_Lpresto_Icon$IconName$$anon$1 };
//# sourceMappingURL=presto.-Icon$-Icon-Name$$anon$1.js.map
